import { render } from "./AIQuestionPage.vue?vue&type=template&id=42800298&scoped=true"
import script from "./AIQuestionPage.vue?vue&type=script&lang=js"
export * from "./AIQuestionPage.vue?vue&type=script&lang=js"

import "./AIQuestionPage.vue?vue&type=style&index=0&id=42800298&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42800298"]])

export default __exports__